export const version = {
  timeStamp: '2026-07-14 10:09:08 AM ',
  version: '0.0.5',
};
